<ng-template
  *ngTemplateOutlet="loading ? documentLoading : documentError ? documentErrorTemplate : documentPreview"
></ng-template>

<ng-template #documentPreview>
  <ngx-extended-pdf-viewer
    [src]="pdfSrc"
    useBrowserLocale="true"
    [page]="currentPage"
    (pageChange)="onPageChange($event)"
    [showOpenFileButton]="false"
    height="90vh"
    (pdfLoadingFailed)="onPdfLoadingFailed($event)"
  ></ngx-extended-pdf-viewer>
</ng-template>

<ng-template #documentErrorTemplate>
  <div class="doc-error">
    <mat-icon class="doc-error__icon">{{ isOfflineError ? 'cloud_off' : 'lock' }}</mat-icon>
    <p class="doc-error__text">{{ documentError | translate }}</p>
  </div>
</ng-template>

<ng-template #documentLoading>
  <mat-spinner diameter="25"></mat-spinner>
</ng-template>
